module.exports = __webpack_public_path__ + "2ef687b172a835659b9951ecafa09cfd.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./app/fonts/fontawesome-webfont.eot?v=4.1.0
 ** module id = 20
 ** module chunks = 0
 **/